import React, { memo } from 'react';
import { Box, Text, SimpleGrid, Heading, HStack } from '@chakra-ui/react';

const ServiceSelection = memo(({ 
  isMensalista, 
  pacoteAtivo, 
  servicosPacote, 
  servicos, 
  usosServicos, 
  selected, 
  setSelected,
  cartProducts = [] // Adicionar cartProducts com valor padrão vazio
}) => {
  if (isMensalista && pacoteAtivo && servicosPacote.length > 0) {
    return (
      <Box
        p={6}
        bg="linear-gradient(180deg, rgba(45,55,72,0.9) 0%, rgba(26,32,44,0.9) 100%)"
        borderRadius="2xl"
        boxShadow="2xl"
        border="1px solid"
        borderColor="whiteAlpha.100"
        backdropFilter="blur(10px)"
        mb={6}
      >
        <HStack mb={6} justify="space-between" align="center">
          <Heading size="md" color="yellow.400" letterSpacing="wide">
            Serviços do Pacote
          </Heading>
        </HStack>
        
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} className="hide-scrollbar">
          {servicosPacote.map((sp) => {
            const servicoDetalhe = servicos.find(s => s.id === sp.servico_id);
            if (!servicoDetalhe) return null;
            const usados = usosServicos[sp.servico_id] || 0;
            const limite = sp.quantidade_inclusa || 0;
            const atingiuLimite = usados >= limite;
            const isSelected = selected.includes(servicoDetalhe.id);
            
            return (
              <Box
                key={sp.servico_id}
                bg="whiteAlpha.50"
                _hover={atingiuLimite ? {} : { bg: isSelected ? 'yellow.500' : 'whiteAlpha.100', transform: 'translateY(-2px)' }}
                transition="all 0.2s"
                borderRadius="xl"
                boxShadow="lg"
                border="1px solid"
                borderColor={isSelected ? "yellow.400" : "whiteAlpha.200"}
                overflow="hidden"
                p={4}
                cursor={atingiuLimite ? 'not-allowed' : 'pointer'}
                opacity={atingiuLimite ? 0.5 : 1}
                pointerEvents={atingiuLimite ? 'none' : 'auto'}
                onClick={() => {
                  if (!atingiuLimite) {
                    setSelected(prev => prev.includes(servicoDetalhe.id) ? prev.filter(id => id !== servicoDetalhe.id) : [...prev, servicoDetalhe.id]);
                  }
                }}
              >
                <HStack spacing={4} align="flex-start">
                  <Box
                    p={isSelected ? 2 : 3}
                    w={isSelected ? "44px" : "40px"}
                    h={isSelected ? "44px" : "40px"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius={isSelected ? "md" : "full"}
                    bg={isSelected ? "yellow.400" : atingiuLimite ? "red.40020" : "green.40020"}
                    color={isSelected ? "black" : atingiuLimite ? "red.400" : "green.400"}
                    fontSize="xl"
                    fontWeight="bold"
                    boxShadow={isSelected ? "md" : "none"}
                    border={isSelected ? "1px solid" : "none"}
                    borderColor={isSelected ? "yellow.500" : atingiuLimite ? "transparent" : "transparent"}
                  >
                    {isSelected ? '✓' : atingiuLimite ? '✖️' : '✂️'}
                  </Box>
                  <Box flex={1}>
                    <Text fontSize="lg" color="white" fontWeight="bold" mb={1}>
                      {servicoDetalhe.nome}
                    </Text>
                    <Text fontSize="sm" color="gray.300" mb={2}>
                      {servicoDetalhe.descricao}
                    </Text>
                    <HStack justify="space-between">
                      <Text fontSize="sm" color={isSelected ? "yellow.300" : atingiuLimite ? "red.300" : "green.300"} fontWeight="bold">
                        {usados}/{limite} usados
                      </Text>
                      <Box 
                        py={1} 
                        px={3} 
                        bg={isSelected ? "yellow.40020" : "whiteAlpha.200"}
                        borderRadius="full"
                        border="1px solid"
                        borderColor={isSelected ? "yellow.400" : "whiteAlpha.300"}
                      >
                        <Text color={isSelected ? "yellow.400" : "gray.300"} fontSize="sm" fontWeight="bold">
                          Qtd: {sp.quantidade_inclusa || sp.quantidade}
                        </Text>
                      </Box>
                    </HStack>
                  </Box>
                </HStack>
              </Box>
            );
          })}
        </SimpleGrid>
      </Box>
    );
  }
  
  return (
    <Box
      p={6}
      bg="linear-gradient(180deg, rgba(45,55,72,0.9) 0%, rgba(26,32,44,0.9) 100%)"
      borderRadius="2xl"
      boxShadow="2xl"
      border="1px solid"
      borderColor="whiteAlpha.100"
      backdropFilter="blur(10px)"
      mb={6}
    >
      <HStack mb={6} justify="space-between" align="center">
        <Heading size="md" color="yellow.400" letterSpacing="wide">
          {isMensalista ? 'Serviços do Pacote' : 'Serviços Disponíveis'}
        </Heading>
      </HStack>
      
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        {servicos.map((servico) => {
          const isSelected = selected.includes(servico.id);
          
          return (
            <Box
              key={servico.id}
              bg="whiteAlpha.50"
              _hover={{ bg: isSelected ? 'yellow.500' : 'whiteAlpha.100', transform: 'translateY(-2px)' }}
              transition="all 0.2s"
              borderRadius="xl"
              boxShadow="lg"
              border="1px solid"
              borderColor={isSelected ? "yellow.400" : "whiteAlpha.200"}
              overflow="hidden"
              p={4}
              cursor="pointer"
              onClick={() => {
                setSelected(prev => prev.includes(servico.id) ? prev.filter(id => id !== servico.id) : [...prev, servico.id]);
              }}
            >
              <HStack spacing={4} align="flex-start">
                <Box
                  p={isSelected ? 2 : 3}
                  w={isSelected ? "44px" : "40px"}
                  h={isSelected ? "44px" : "40px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius={isSelected ? "md" : "full"}
                  bg={isSelected ? "yellow.400" : "yellow.40020"}
                  color={isSelected ? "black" : "yellow.400"}
                  fontSize="xl"
                  fontWeight="bold"
                  boxShadow={isSelected ? "md" : "none"}
                  border={isSelected ? "1px solid" : "none"}
                  borderColor={isSelected ? "yellow.500" : "transparent"}
                >
                  {isSelected ? '✓' : '✂️'}
                </Box>
                <Box flex={1}>
                  <Text fontSize="lg" color="white" fontWeight="bold" mb={1}>
                    {servico.nome}
                  </Text>
                  <Text fontSize="sm" color="gray.300" mb={2}>
                    {servico.descricao}
                  </Text>
                  {/* Exibir valor apenas para usuários não mensalistas */}
                  {!isMensalista && (
                    <Box 
                      py={1} 
                      px={3} 
                      bg="green.40020"
                      borderRadius="full"
                      border="1px solid"
                      borderColor="green.400"
                      display="inline-block"
                    >
                      <Text color="green.400" fontSize="md" fontWeight="bold">
                        R$ {typeof servico.valor === 'number' ? servico.valor.toFixed(2).replace('.', ',') : '--'}
                      </Text>
                    </Box>
                  )}
                </Box>
              </HStack>
            </Box>
          );
        })}
      </SimpleGrid>
      
      {/* O total de serviços foi removido e agora é exibido apenas no componente TotalGeral */}
    </Box>
  );
});

export default ServiceSelection;
